/** Tab-Titel blinken lassen, wenn man am Zug ist und der Tab im Hintergrund liegt.
 *  Kein Permission-Prompt nötig (anders als die Notification-API). */

const BASE_TITLE = 'Würfeln — KCD2';
const FLASH_TEXT = '🎲 Du bist dran!';

let flashTimer: number | null = null;
let listenerBound = false;

function bindOnce(): void {
  if (listenerBound) return;
  listenerBound = true;
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) stopTitleFlash();
  });
}

export function flashTitleYourTurn(): void {
  bindOnce();
  if (!document.hidden) return; // im Vordergrund nicht nötig
  if (flashTimer != null) return;
  let on = false;
  flashTimer = window.setInterval(() => {
    on = !on;
    document.title = on ? FLASH_TEXT : BASE_TITLE;
  }, 900);
}

export function stopTitleFlash(): void {
  if (flashTimer != null) {
    clearInterval(flashTimer);
    flashTimer = null;
  }
  document.title = BASE_TITLE;
}
